export default __webpack_public_path__ + "static/media/person-6.2415ff9d.png";